(function () {
  var config = window.PuroAqiData || {};
  var apiKey = config.apiKey || '';
  var mapsScriptUrl = config.mapsScriptUrl || '';
  var mapsPromise = null;
  var ipLoadStarted = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function qsa(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function setText(selector, value) {
    qsa(selector).forEach(function (el) {
      el.textContent = value == null ? '' : value;
    });
  }

  function setBackground(selector, value) {
    qsa(selector).forEach(function (el) {
      el.style.backgroundColor = value || '';
    });
  }

  function show(selector) {
    qsa(selector).forEach(function (el) {
      el.style.display = '';
    });
  }

  function hide(selector) {
    qsa(selector).forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function loadGoogleMaps() {
    if (window.google && window.google.maps && window.google.maps.Geocoder) {
      return Promise.resolve();
    }

    if (mapsPromise) {
      return mapsPromise;
    }

    mapsPromise = new Promise(function (resolve, reject) {
      if (!mapsScriptUrl) {
        reject(new Error('Google Maps URL missing'));
        return;
      }

      window.puroAqiGoogleMapsReady = function () {
        resolve();
      };

      var script = document.createElement('script');
      script.src = mapsScriptUrl;
      script.async = true;
      script.defer = true;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return mapsPromise;
  }

  async function fetchZipCodeFromIP() {
    try {
      var response = await fetch('https://api.klaygoods.com/get_zip_code_from_ip.php');
      var data = await response.json();
      return data.zip_code || null;
    } catch (error) {
      return null;
    }
  }

  function extractZipCode(locationDetails) {
    var zipCode = '';
    var addressComponents = locationDetails.address_components || [];

    for (var i = 0; i < addressComponents.length; i++) {
      if (addressComponents[i].types.includes('postal_code')) {
        zipCode = addressComponents[i].long_name;
        break;
      }
    }

    return zipCode;
  }

  function promiseWithTimeout(promise, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var timeoutId = setTimeout(function () {
        reject(new Error('Timed out'));
      }, timeoutMs);

      promise
        .then(function (res) {
          clearTimeout(timeoutId);
          resolve(res);
        })
        .catch(function (err) {
          clearTimeout(timeoutId);
          reject(err);
        });
    });
  }

  async function loadAirQualityFromIP() {
    if (ipLoadStarted) {
      return;
    }

    ipLoadStarted = true;

    try {
      await loadGoogleMaps();
      var location = await promiseWithTimeout(fetchZipCodeFromIP(), 3000);

      if (location) {
        displaydata(location);
      } else {
        markDataUnavailable();
      }
    } catch (err) {
      markDataUnavailable();
    }
  }

  function requestGeolocationPermission() {
    ipLoadStarted = true;
    clearPreviousData();

    loadGoogleMaps()
      .then(function () {
        if (!navigator.geolocation) {
          markDataUnavailable();
          return;
        }

        navigator.geolocation.getCurrentPosition(
          function (position) {
            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;
            var geocoder = new google.maps.Geocoder();
            var latlng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

            geocoder.geocode({ location: latlng }, function (results, status) {
              if (status === 'OK' && results[0]) {
                var postalCode = extractZipCode(results[0]);

                if (postalCode) {
                  hide('.locationbutton');
                  clearPreviousData();
                  displaydata(postalCode);
                  return;
                }
              }

              markDataUnavailable();
            });
          },
          function () {
            markDataUnavailable();
          }
        );
      })
      .catch(function () {
        markDataUnavailable();
      });
  }

  function clearPreviousData() {
    setText('.outdoor_aqi', '');
    setText('.outdoor_aqi_cat', '');
    setText('.indoor_aqi', '');
    setText('.indoor_aqi_cat', '');
    setText('.pollen_count', '');
    setText('.pollen_cat', '');
    setText('.humidity', '');
    setText('.humidity_cat', '');
    setBackground('.outdoor_aqi', '');
    setBackground('.indoor_aqi', '');
    setBackground('.pollen_count', '');
    setBackground('.humidity', '');
    show('.loading-aqi-outdoor');
    show('.loading-aqi-indoor');
    show('.loading-pollen');
    show('.loading-humidity');
  }

  function markDataUnavailable() {
    hide('.loading-aqi-outdoor');
    hide('.loading-aqi-indoor');
    hide('.loading-pollen');
    hide('.loading-humidity');
    setText('.outdoor_aqi', '—');
    setText('.indoor_aqi', '—');
    setText('.pollen_count', '—');
    setText('.humidity', '—');
  }

  function displaydata(location) {
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: location }, function (results, status) {
      if (status !== 'OK' || !results[0]) {
        markDataUnavailable();
        return;
      }

      var locationDetails = results[0];
      var locationLatLng = locationDetails.geometry.location;
      var zipCode = extractZipCode(locationDetails) || location;
      var lat = locationLatLng.lat();
      var lng = locationLatLng.lng();
      var url = 'https://airquality.googleapis.com/v1/currentConditions:lookup?key=' + apiKey;
      var postData = {
        location: {
          latitude: lat,
          longitude: lng
        },
        universalAqi: true,
        extraComputations: ['LOCAL_AQI'],
        customLocalAqis: [
          {
            regionCode: 'US',
            aqi: 'usa_epa'
          }
        ]
      };

      setText('.zipcode_data', zipCode);

      makeAjaxRequest(url, postData)
        .then(function (response) {
          var aqiOutdoor = response.aqiValue;
          var aqiIndoor = Math.ceil(response.aqiValue + response.aqiValue * 2.0);
          var aqiInfoOutdoor = calculateAQICategory(response.aqiValue);
          var aqiInfoIndoor = calculateAQICategory(aqiIndoor);

          hide('.loading-aqi-outdoor');
          setText('.outdoor_aqi', aqiOutdoor);
          setBackground('.outdoor_aqi', aqiInfoOutdoor.color);
          setText('.outdoor_aqi_cat', aqiInfoOutdoor.label);

          hide('.loading-aqi-indoor');
          setText('.indoor_aqi', aqiIndoor);
          setBackground('.indoor_aqi', aqiInfoIndoor.color);
          setText('.indoor_aqi_cat', aqiInfoIndoor.label);
        })
        .catch(function () {
          hide('.loading-aqi-outdoor');
          hide('.loading-aqi-indoor');
          setText('.outdoor_aqi', '—');
          setText('.indoor_aqi', '—');
        });

      getPollenIndex(lat, lng).then(function (pollenindex) {
        hide('.loading-pollen');

        if (pollenindex == null) {
          setText('.pollen_count', '—');
          return;
        }

        var pollenCat = getPollenCategory(pollenindex);
        setText('.pollen_count', pollenindex);
        setText('.pollen_cat', pollenCat.label);
        setBackground('.pollen_count', pollenCat.color);
      });

      getHumidity(lat, lng).then(function (humidity) {
        hide('.loading-humidity');

        if (humidity == null) {
          setText('.humidity', '—');
          return;
        }

        var humidityCat = getHumidityCategory(humidity);
        setText('.humidity', humidity + '%');
        setText('.humidity_cat', humidityCat.label);
        setBackground('.humidity', humidityCat.color);
      });
    });
  }

  async function getHumidity(lat, lng) {
    try {
      var response = await fetch('https://api.klaygoods.com/humidity-proxy.php?lat=' + lat + '&lon=' + lng);
      var data = await response.json();
      return data.relativeHumidity !== undefined ? data.relativeHumidity : null;
    } catch (error) {
      return null;
    }
  }

  async function getPollenIndex(lat, lng) {
    try {
      var response = await fetch('https://api.klaygoods.com/pollen-proxy.php?lat=' + lat + '&lon=' + lng);
      var data = await response.json();
      var pollenTypes = ['GRASS', 'TREE', 'WEED'];
      var maxIndex = null;
      var pollenInfo = (data.dailyInfo && data.dailyInfo[0] && data.dailyInfo[0].pollenTypeInfo) || [];

      for (var i = 0; i < pollenInfo.length; i++) {
        var item = pollenInfo[i];

        if (pollenTypes.includes(item.code) && item.indexInfo && item.indexInfo.value != null) {
          if (maxIndex === null || item.indexInfo.value > maxIndex) {
            maxIndex = item.indexInfo.value;
          }
        }
      }

      return maxIndex;
    } catch (error) {
      return null;
    }
  }

  function makeAjaxRequest(url, data) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            var responseData = JSON.parse(xhr.responseText);
            resolve({
              aqiValue: responseData.indexes[0].aqi,
              aqiCategory: responseData.indexes[0].category
            });
          } else {
            reject(xhr.status);
          }
        }
      };
      xhr.send(JSON.stringify(data));
    });
  }

  function calculateAQICategory(aqiValue) {
    if (aqiValue <= 50) return { label: 'Good', color: '#4CAF50' };
    if (aqiValue <= 100) return { label: 'Moderate', color: '#FFEB3B' };
    if (aqiValue <= 150) return { label: 'Unhealthy', color: '#FF9800' };
    if (aqiValue <= 200) return { label: 'Unhealthy', color: '#F44336' };
    if (aqiValue <= 300) return { label: 'Very Unhealthy', color: '#9C27B0' };
    return { label: 'Hazardous', color: '#7E0023' };
  }

  function getPollenCategory(pollenIndex) {
    if (pollenIndex === 0) return { label: 'None', color: '#cccccc' };
    if (pollenIndex <= 1.0) return { label: 'Very Low', color: '#4CAF50' };
    if (pollenIndex <= 2.0) return { label: 'Low', color: '#8BC34A' };
    if (pollenIndex <= 3.0) return { label: 'Moderate', color: '#FFC107' };
    if (pollenIndex <= 4.0) return { label: 'High', color: '#FF9800' };
    if (pollenIndex <= 5.0) return { label: 'Very High', color: '#F44336' };
    return { label: 'Unknown', color: '#9E9E9E' };
  }

  function getHumidityCategory(humidity) {
    if (humidity < 30) return { label: 'Low (Dry)', color: '#00BCD4' };
    if (humidity <= 50) return { label: 'Ideal', color: '#4CAF50' };
    if (humidity <= 60) return { label: 'Slightly High', color: '#CDDC39' };
    if (humidity <= 70) return { label: 'High', color: '#FFC107' };
    if (humidity <= 100) return { label: 'Very High', color: '#F44336' };
    return { label: 'Unknown', color: '#9E9E9E' };
  }

  function scheduleInitialLoad() {
    window.addEventListener(
      'load',
      function () {
        var start = function () {
          loadAirQualityFromIP();
        };

        if ('requestIdleCallback' in window) {
          requestIdleCallback(start, { timeout: 2500 });
        } else {
          setTimeout(start, 1200);
        }
      },
      { once: true }
    );
  }

  ready(function () {
    qsa('.locationbutton').forEach(function (button) {
      button.addEventListener('click', requestGeolocationPermission);
    });

    scheduleInitialLoad();
  });

  window.loadAirQualityFromIP = loadAirQualityFromIP;
  window.requestGeolocationPermission = requestGeolocationPermission;
})();
